import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";

import { alert } from './modules/alert';
import { account } from './modules/account';
import { basket } from './modules/basket';
import { localeChanged } from 'vee-validate';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        alert: alert,
        account: account,
        basket: basket
    },
    state: {
        authenticated: false,
        validationErrors: {},
        lastRoute: null,
        referringOrganisation: null,
        promoCode: null,
        locale: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? 'es' : 'en',
        brand: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? 'neotag' : 'findmykit',
        brandName: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? 'NEOTAG' : 'Findmykit'
    },
    actions: {
        setLocale({ commit }, locale) {
            localeChanged();
            commit('setLocale', locale);
        },
        validationErrors({ commit }, errors) {
            console.log(errors)
            console.log("action")
            commit('validationErrors', errors);
        },
        lastRoute({ commit }, route) {
            commit('lastRoute', route);
        },
        referringOrganisation({ commit }, referringOrganisation) {
            commit('referringOrganisation', referringOrganisation);
        },
        setPromoCode({ commit }, promo) {
            commit('setPromoCode', promo);
        },
    },
    mutations: {
        setLocale (state, locale) {
            state.locale = locale
        },
        loggedIn (state) {
            state.authenticated = true
        },
        loggedOut (state) {
            state.authenticated = false
        },
        validationErrors (state, errors) {
            console.log(errors)
            console.log("mutate")
            state.validationErrors = errors
        },
        lastRoute (state, route) {
            state.lastRoute = route
        },
        referringOrganisation (state, referringOrganisation) {
            state.referringOrganisation = referringOrganisation
        },
        setPromoCode (state, promo) {
            state.promoCode = promo
        },
    },
    getters: {
        locale: (state) => {
            return state.locale
        },
        userHasRole: (state) => (roles) => {

            let user = state.account.user
            if (user.roles) {
                for (let role of roles){
                    if (user.roles.includes(role)) {
                        return true
                    }
                }
            }

            return false
        },
        userHasOrganisation: (state) => (slug) => {

            let user = state.account.user
            if (user.organisations) {
                for (let organisation of user.organisations){
                    if (organisation.slug === slug) {
                        return true
                    }
                }
            }

            return false
        },
        validationErrors: (state) => {
            return state.validationErrors
        },
        isAuthenticated: (state) => {
            return state.authenticated
        },
    },
    plugins: [createPersistedState()]
});
